// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__ZVq1w","itemTitle":"ClientEmergencyInfo_itemTitle__2ojBC","itemText":"ClientEmergencyInfo_itemText__3g9m1"};